import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { useEventos } from "../../context/EventosContext";
import Sidebar from "../../components/sidebar/Sidebar";
import { QRCodeCanvas } from "qrcode.react";





import {
  PageLayout,
  Container,
  Header,
  Title,
  Subtitle,
  SearchInput,
  AddButton,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusBadge,
  ActionIcons,
  EventInfo,
  EventTitle,
  EventSubtitle,
  SearchWrapper,
  SortWrapper,
  HighlightRow,
  ModalContent,
  ModalOverlay,
  ModalImageHeader,
  ModalSection,
  ModalInfoItem,
  ModalInfoIcon,
  ModalInfoText,
  ModalTag,              // ✅ ADICIONE
  ModalRememberButton,  
  ModalCloseButton
} from "./styles";

import {
  Eye,
  Edit,
  Trash2,
  Plus,
  Search,
  Star,
  Calendar,
  MapPin,
  Lock,
  Unlock,
  Users,
  X
} from "lucide-react";



/* 🔹 Helper imagem */
const getImagemUrl = (imagem) => {
  if (!imagem) return "https://placehold.co/600x200?text=Sem+Imagem";
  if (imagem.startsWith("http")) return imagem;

  const baseURL = api.defaults.baseURL;
  return `${baseURL}/${imagem.replace(/^\/?/, "")}`;
};

/* 🔹 Helper data (MongoDB) */
const formatarData = (data) => {
  if (!data) return "—";
  if (typeof data === "object" && data.$date) {
    return new Date(data.$date).toLocaleDateString("pt-BR");
  }
  return new Date(data).toLocaleDateString("pt-BR");
};

const Eventos = () => {
  const navigate = useNavigate();
  const { eventos = [], setEventos } = useEventos() || {};

  const [selectedId, setSelectedId] = useState(null);
  const [sortType, setSortType] = useState("az");
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [eventoSelecionado, setEventoSelecionado] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showQRCode, setShowQRCode] = useState(false);




  const downloadQRCode = () => {
  const canvas = document.getElementById("evento-qrcode");
  if (!canvas) return;

  const url = canvas.toDataURL("image/png");
  const link = document.createElement("a");
  link.href = url;
  link.download = `${eventoSelecionado.titulo || "qrcode"}.png`;
  link.click();
};


  // 🔹 Buscar eventos
  useEffect(() => {
    const fetchEventos = async () => {
      try {
        const response = await api.get("/api/content/eventos");
        setEventos(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Erro ao buscar eventos:", error);
        setEventos([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEventos();
  }, [setEventos]);

  // 🔹 Deletar evento
  const handleDelete = async (id, e) => {
    e.stopPropagation();

    if (!window.confirm("Deseja excluir este evento?")) return;

    try {
      await api.delete(`/api/content/eventos/${id}`);
      setEventos((prev) =>
        prev.filter((ev) => (ev._id || ev.id) !== id)
      );
    } catch (error) {
      alert("Erro ao deletar evento.");
    }
  };

  // 🔹 Toggle destaque
  const toggleHighlight = async (id, e) => {
    e.stopPropagation();

    const eventoAtual = eventos.find(
      (ev) => (ev._id || ev.id) === id
    );

    if (!eventoAtual) return;

    const novoValor = !eventoAtual.destacado;

    setEventos((prev) =>
      prev.map((ev) =>
        (ev._id || ev.id) === id
          ? { ...ev, destacado: novoValor }
          : ev
      )
    );

    try {
      await api.put(`/api/content/eventos/${id}`, {
        destacado: novoValor,
      });
    } catch (error) {
      setEventos((prev) =>
        prev.map((ev) =>
          (ev._id || ev.id) === id
            ? { ...ev, destacado: eventoAtual.destacado }
            : ev
        )
      );
    }
  };

  // 🔹 Filtro
  const filtered = eventos.filter(
    (ev) =>
      ev.titulo?.toLowerCase().includes(query.toLowerCase()) ||
      ev.local?.toLowerCase().includes(query.toLowerCase())
  );

  // 🔹 Ordenação
  const sortEventos = (list) => {
    const copy = [...list];

    if (sortType === "az") {
      copy.sort((a, b) => a.titulo.localeCompare(b.titulo));
    }

    if (sortType === "za") {
      copy.sort((a, b) => b.titulo.localeCompare(a.titulo));
    }

    if (sortType === "highlighted") {
      copy.sort(
        (a, b) =>
          (b.destacado ? 1 : 0) - (a.destacado ? 1 : 0) ||
          a.titulo.localeCompare(b.titulo)
      );
    }

    return copy;
  };

  const displayed = sortEventos(filtered);

  return (
    <PageLayout>
      <Sidebar />

      <Container>
        <Header>
          <div>
            <Title>Gerenciar eventos</Title>
            <Subtitle>Crie e gerencie eventos da comunidade</Subtitle>
          </div>

          <AddButton onClick={() => navigate("/criar-evento")}>
            <Plus size={18} />
            Novo evento
          </AddButton>
        </Header>

        <SortWrapper>
          <label>Ordenar por:</label>
          <select value={sortType} onChange={(e) => setSortType(e.target.value)}>
            <option value="az">A–Z</option>
            <option value="za">Z–A</option>
            <option value="highlighted">Destaques</option>
          </select>
        </SortWrapper>

        <SearchWrapper>
          <Search size={18} />
          <SearchInput
            placeholder="Pesquisar eventos..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </SearchWrapper>

        <Table>
          <thead>
            <TableRow header>
              <TableHeader>Título</TableHeader>
              <TableHeader>Data</TableHeader>
              <TableHeader>Local</TableHeader>
              <TableHeader>Status</TableHeader>
              <TableHeader>Ações</TableHeader>
            </TableRow>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={{ padding: 40, textAlign: "center" }}>
                  Carregando eventos...
                </td>
              </tr>
            ) : displayed.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ padding: 40, textAlign: "center" }}>
                  Nenhum evento encontrado.
                </td>
              </tr>
            ) : (
              displayed.map((evento) => {
                const eventoId = evento._id || evento.id;

                return (
                  <HighlightRow
                    key={eventoId}
                    highlighted={evento.destacado}
                    selected={selectedId === eventoId}
                    onClick={() => setSelectedId(eventoId)}
                  >
                    <TableCell>
                      <EventInfo>
                        {evento.destacado && <span>⭐ DESTACADO</span>}
                        <EventTitle>{evento.titulo}</EventTitle>
                        <EventSubtitle>{evento.descricao}</EventSubtitle>
                      </EventInfo>
                    </TableCell>

                    <TableCell>
                      {formatarData(evento.data)}
                    </TableCell>

                    <TableCell>{evento.local}</TableCell>

                    <TableCell>
                      <StatusBadge>{evento.status}</StatusBadge>
                    </TableCell>

                    <TableCell>
                      <ActionIcons>
                        <Star
                          size={18}
                          color={evento.destacado ? "#2563eb" : "#9ca3af"}
                          onClick={(e) => toggleHighlight(eventoId, e)}
                        />

                        <Eye
                          size={18}
                          onClick={(e) => {
                            e.stopPropagation();
                            setEventoSelecionado(evento);
                            setShowModal(true);
                          }}
                        />

                        <Edit
                          size={18}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/editar-evento/${eventoId}`);
                          }}
                        />

                        <Trash2
                          size={18}
                          color="#EF4444"
                          onClick={(e) => handleDelete(eventoId, e)}
                        />
                      </ActionIcons>
                    </TableCell>
                  </HighlightRow>
                );
              })
            )}
          </tbody>
        </Table>
      </Container>

      {/* 🔥 MODAL VISUALIZAÇÃO */}
    {/* 🔥 MODAL VISUALIZAÇÃO */}
{showModal && eventoSelecionado && (
  <ModalOverlay onClick={() => setShowModal(false)}>
    <ModalContent onClick={(e) => e.stopPropagation()}>
      <ModalCloseButton onClick={() => setShowModal(false)}>
  <X size={18} />
</ModalCloseButton>

      {/* 🖼️ IMAGEM DO EVENTO */}
      <ModalImageHeader>
        {eventoSelecionado.imagem ? (
          <img
            src={getImagemUrl(eventoSelecionado.imagem)}
            alt={eventoSelecionado.titulo}
          />
        ) : (
          <div className="placeholder">Sem imagem</div>
        )}
      </ModalImageHeader>

      {/* 📌 CONTEÚDO */}
      <div style={{ padding: "1.5rem", overflowY: "auto" }}>
        <h2>{eventoSelecionado.titulo}</h2>
        <p>{eventoSelecionado.descricao}</p>

        {/* INFO PRINCIPAL */}
        <ModalSection>
          <ModalInfoItem>
            <ModalInfoIcon color="#2563eb">
              <Calendar size={18} />
            </ModalInfoIcon>
            <ModalInfoText>
              {formatarData(eventoSelecionado.data)} às {eventoSelecionado.hora}
            </ModalInfoText>
          </ModalInfoItem>

          <ModalInfoItem>
            <ModalInfoIcon color="#16a34a">
              <MapPin size={18} />
            </ModalInfoIcon>
            <ModalInfoText>{eventoSelecionado.local}</ModalInfoText>
          </ModalInfoItem>

          <ModalInfoItem>
            <ModalInfoIcon color="#7c3aed">
              {eventoSelecionado.acesso === "Privado"
                ? <Lock size={18} />
                : <Unlock size={18} />}
            </ModalInfoIcon>
            <ModalInfoText>{eventoSelecionado.acesso}</ModalInfoText>
          </ModalInfoItem>

          <ModalInfoItem>
            <ModalInfoIcon color="#0ea5e9">
              <Users size={18} />
            </ModalInfoIcon>
            <ModalInfoText>
              {eventoSelecionado.vagas
                ? `${eventoSelecionado.vagas} vagas`
                : "Vagas ilimitadas"}
            </ModalInfoText>
          </ModalInfoItem>
        </ModalSection>

        {/* ORGANIZADOR */}
        <ModalSection>
          <strong>Organizador</strong>
          <p>{eventoSelecionado.organizador}</p>
        </ModalSection>

     


        {/* STATUS */}
        <ModalSection>
          <strong>Status</strong>
          <StatusBadge>{eventoSelecionado.status}</StatusBadge>
        </ModalSection>

        {/* TAGS */}
        <ModalSection>
          <strong>Tags</strong>
          {eventoSelecionado.tags?.length > 0 ? (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
              {eventoSelecionado.tags.map((tag, i) => (
                <ModalTag key={i}>#{tag}</ModalTag>
              ))}
            </div>
          ) : (
            <p>Sem tags</p>
          )}
        </ModalSection>

        {/* CONTEÚDOS */}
        <ModalSection>
          <strong>Conteúdos</strong>
          {eventoSelecionado.conteudos?.length > 0 ? (
            eventoSelecionado.conteudos.map((conteudo) => (
              <div key={conteudo._id?.$oid} style={{ marginTop: 8 }}>
                <p><strong>{conteudo.titulo}</strong></p>
                <ul>
                  {conteudo.itens
                    .filter((item) => item.trim() !== "")
                    .map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                </ul>
              </div>
            ))
          ) : (
            <p>Nenhum conteúdo cadastrado.</p>
          )}
        </ModalSection>

        {/* CONTATOS */}
        <ModalSection>
          <strong>Contatos</strong>
          {eventoSelecionado.contatos?.some(
            (c) => c.telefone || c.email || c.redeSocial
          ) ? (
            eventoSelecionado.contatos.map((c, i) => (
              <div key={i}>
                {c.telefone && <p>📞 {c.telefone}</p>}
                {c.email && <p>📧 {c.email}</p>}
                {c.redeSocial && <p>🌐 {c.redeSocial}</p>}
              </div>
            ))
          ) : (
            <p>Nenhum contato informado.</p>
          )}
        </ModalSection>

        {/* XP / LIKES / DESTAQUE */}
        <ModalSection>
          <p><strong>XP:</strong> {eventoSelecionado.xp}</p>
          <p><strong>Likes:</strong> {eventoSelecionado.likes}</p>
          <p>
            <strong>Destaque:</strong>{" "}
            {eventoSelecionado.destacado ? "Sim ⭐" : "Não"}
          </p>
        </ModalSection>

        {/* CRIADO EM */}
        <ModalSection>
          <strong>Criado em</strong>
          <p>{formatarData(eventoSelecionado.criadoEm)}</p>
        </ModalSection>

           {/* BOTÃO DE GERAR QR CODE */}
<ModalSection>
  <strong>Check-in</strong>
  <div
    style={{
      marginTop: 16,
      display: "flex",
      flexDirection: "column",
      alignItems: "center", // centraliza horizontalmente
      gap: 12,
    }}
  >
    <button
      style={{
        padding: "8px 12px",
        backgroundColor: "#2563eb",
        color: "#fff",
        border: "none",
        borderRadius: 6,
        cursor: "pointer",
      }}
      onClick={() => setShowQRCode((prev) => !prev)}
    >
      {showQRCode ? "Ocultar QR Code" : "Gerar QR Code"}
    </button>

    {showQRCode && (
      <>
        <QRCodeCanvas
          id="evento-qrcode"
          value={`content/eventos/${eventoSelecionado._id || eventoSelecionado.id}/checkin`}
          size={180}
        />
        <button
          style={{
            padding: "6px 10px",
            backgroundColor: "#16a34a",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
          onClick={downloadQRCode}
        >
          Baixar QR Code
        </button>
      </>
    )}
  </div>
</ModalSection>


        
      </div>

    </ModalContent>
  </ModalOverlay>
)}


    </PageLayout>
  );
};

export default Eventos;
